(function () {
  function moneyFormat(cents, locale, currency) {
    var value = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat(locale || "en-US", {
        style: "currency",
        currency: currency || "USD",
      }).format(value);
    } catch (e) {
      return "$" + value.toFixed(2);
    }
  }

  function clampQty(input, nextVal) {
    var maxAttr = input.getAttribute("data-max-qty") || input.getAttribute("max");
    var max = parseInt(maxAttr || "0", 10);
    var val = parseInt(nextVal || "0", 10);

    if (isNaN(val) || val < 0) val = 0;

    // safety cap
    var globalMax = 9999;
    if (val > globalMax) val = globalMax;

    if (max && val > max) val = max;

    return val;
  }

  function closeQuickViewFrom(grid) {
    // Try to find a reasonable modal container around the grid (theme/app agnostic)
    var modal =
      (grid &&
        grid.closest &&
        grid.closest(
          '[role="dialog"], dialog, .modal, .drawer, .quick-view, .quickview, [data-quick-view], [data-modal], [data-drawer]'
        )) ||
      document.querySelector(
        '[role="dialog"][open], dialog[open], .modal.is-active, .modal.active, .drawer.is-active, .drawer.active, .quick-view.is-active, .quickview.is-active'
      );

    if (modal) {
      // Prefer clicking an explicit close button if present
      var closeBtn =
        modal.querySelector(
          '[data-close], [data-modal-close], [data-drawer-close], .modal__close, .drawer__close, .quick-view__close, .quickview__close, button[aria-label="Close"], button[title="Close"]'
        ) || null;

      if (closeBtn) {
        closeBtn.click();
        return;
      }

      // If it's a <dialog>, close it
      if (typeof modal.close === "function") {
        modal.close();
        return;
      }

      // Fallback: hide + remove common open classes
      modal.classList.remove("is-active", "active", "open");
      modal.setAttribute("aria-hidden", "true");
      modal.style.display = "none";
      return;
    }

    // Last resort: dispatch close events some implementations listen for
    document.dispatchEvent(new CustomEvent("quickview:close", { bubbles: true }));
    document.dispatchEvent(new CustomEvent("quick-view:close", { bubbles: true }));
  }

  function updateGridTotals(grid) {
    var totalPriceEl = grid.querySelector("[data-total-price]");
    var totalUnitsEl = grid.querySelector("[data-total-units]");
    var submitBtn = grid.querySelector("[data-variant-grid-submit]");
    var btnTextEl = submitBtn && submitBtn.querySelector(".btn__text");

    var currency = grid.getAttribute("data-currency") || "USD";
    var locale = grid.getAttribute("data-locale") || "en-US";

    var totalCents = 0;
    var totalUnits = 0;

    grid.querySelectorAll("[data-variant-row]").forEach(function (row) {
      var qtyInput = row.querySelector("[data-variant-qty]");
      var hidden = row.querySelector("[data-variant-qty-hidden]");
      if (!qtyInput) return;

      var priceCents = parseInt(row.getAttribute("data-variant-price"), 10) || 0;
      var qty = clampQty(qtyInput, qtyInput.value);

      // keep inputs in sync
      if (qtyInput.value !== String(qty)) qtyInput.value = qty;
      if (hidden) hidden.value = qty;

      var lineCents = qty * priceCents;
      totalCents += lineCents;
      totalUnits += qty;

      var lineEl = row.querySelector("[data-line-total]");
      if (lineEl) lineEl.textContent = lineCents > 0 ? moneyFormat(lineCents, locale, currency) : "–";
    });

    if (totalPriceEl) totalPriceEl.textContent = moneyFormat(totalCents, locale, currency);
    if (totalUnitsEl) totalUnitsEl.textContent = totalUnits;

    // shipping message logic (based on total units)
    var shippingWrapper = grid.querySelector("[data-shipping-message]");
    var shippingTextEl = grid.querySelector("[data-shipping-text]");
    if (shippingWrapper && shippingTextEl) {
      if (!totalUnits || totalUnits <= 0) {
        shippingWrapper.style.display = "none";
      } else {
        shippingWrapper.style.display = "flex";
        shippingTextEl.textContent =
          totalUnits < 2700
            ? "Shipped via normal UPS (5–7 business days)."
            : "Shipping via pallets. Time varies depending on location.";
      }
    }

    if (submitBtn) {
      if (totalCents > 0) {
        submitBtn.disabled = false;
        if (btnTextEl && btnTextEl.textContent !== "Adding...") btnTextEl.textContent = "Add Selected To Cart";
      } else {
        submitBtn.disabled = true;
        if (btnTextEl) btnTextEl.textContent = "Choose Quantities";
      }
    }
  }

  function initGrid(grid) {
    if (!grid || grid.dataset.variantGridInitialized === "true") return;
    grid.dataset.variantGridInitialized = "true";

    // Ensure starting UI state
    var submitBtn = grid.querySelector("[data-variant-grid-submit]");
    var btnTextEl = submitBtn && submitBtn.querySelector(".btn__text");
    if (submitBtn) {
      submitBtn.disabled = true;
      if (btnTextEl) btnTextEl.textContent = "Choose Quantities";
    }

    updateGridTotals(grid);
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll("[data-variant-grid-root]")
      .forEach(initGrid);
  }

  // Event delegation for + / - and manual input
  document.addEventListener(
    "click",
    function (e) {
      var btn = e.target.closest(".vg-qty-btn");
      if (!btn) return;

      var grid = btn.closest("[data-variant-grid-root]");
      if (!grid) return;

      // stop “click outside closes modal” style quick-views from eating clicks
      e.stopPropagation();

      var row = btn.closest("[data-variant-row]");
      var input = row && row.querySelector("[data-variant-qty]");
      if (!input) return;

      var current = parseInt(input.value || "0", 10) || 0;
      var next = btn.classList.contains("vg-qty-btn--plus") ? current + 1 : current - 1;

      input.value = clampQty(input, next);
      updateGridTotals(grid);
    },
    true
  );

  document.addEventListener("input", function (e) {
    var input = e.target.closest("[data-variant-qty]");
    if (!input) return;

    var grid = input.closest("[data-variant-grid-root]");
    if (!grid) return;

    input.value = clampQty(input, input.value);
    updateGridTotals(grid);
  });

  // Bind submit per grid/form (scoped!)
  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (!form || !form.matches("form")) return;

      var grid = form.querySelector("[data-variant-grid-root]");
      if (!grid) return;

      // This is our form — hijack to AJAX add
      e.preventDefault();

      var submitBtn = grid.querySelector("[data-variant-grid-submit]");
      var btnTextEl = submitBtn && submitBtn.querySelector(".btn__text");

      var formData = new FormData();
      var index = 0;
      var hasItems = false;

      grid.querySelectorAll("[data-variant-row]").forEach(function (row) {
        var qtyInput = row.querySelector("[data-variant-qty]");
        if (!qtyInput) return;

        var qty = parseInt(qtyInput.value || "0", 10);
        if (isNaN(qty) || qty <= 0) return;

        var variantId = row.getAttribute("data-variant-id");
        if (!variantId) return;

        formData.append("items[" + index + "][id]", variantId);
        formData.append("items[" + index + "][quantity]", qty);
        index++;
        hasItems = true;
      });

      if (!hasItems) return;

      if (submitBtn) {
        submitBtn.disabled = true;
        if (btnTextEl) btnTextEl.textContent = "Adding...";
      }

      var root =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : "/";

      fetch(root + "cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) {
              var message =
                (data && (data.description || data.message || data.errors)) ||
                "Add to cart failed";
              throw new Error(message);
            }
            return data;
          });
        })
        .then(function () {
          return fetch(root + "cart.js", { headers: { Accept: "application/json" } });
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          document.querySelectorAll("cart-count").forEach(function (el) {
            el.textContent = cart.item_count;
            el.setAttribute("aria-label", cart.item_count + " items");
            el.hidden = cart.item_count === 0;
          });

          document.dispatchEvent(
            new CustomEvent("cart:refresh", { bubbles: true, detail: { open: true } })
          );

          // ✅ close quick view after add to cart
          closeQuickViewFrom(grid);

          // reset quantities
          grid.querySelectorAll("[data-variant-qty]").forEach(function (input) {
            input.value = 0;
          });
          updateGridTotals(grid);
        })
        .catch(function (error) {
          console.error("Variant grid add error:", error);
          alert(error.message || "There was a problem adding these items to your cart.");

          if (submitBtn) {
            if (btnTextEl) btnTextEl.textContent = "Add Selected To Cart";
            submitBtn.disabled = false;
          }
        });
    },
    true
  );

  // Initial load
  document.addEventListener("DOMContentLoaded", function () {
    initAll(document);
  });

  // Theme editor section load
  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target || document);
  });

  // Quick view / injected HTML safety net
  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (!m.addedNodes) continue;
      for (var j = 0; j < m.addedNodes.length; j++) {
        var node = m.addedNodes[j];
        if (!node || node.nodeType !== 1) continue;

        if (node.matches && node.matches("[data-variant-grid-root]")) {
          initGrid(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll("[data-variant-grid-root]").forEach(initGrid);
        }
      }
    }
  });

  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
